import React from 'react';
import { AlertTriangle, ArrowUpRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './OverLimitBanner.scss';

/**
 * Persistent banner shown on entity list pages when the institute
 * is at or over their plan limit for that resource.
 *
 * Props:
 *   resourceName  — Human label, e.g. "Students"
 *   used          — Current count
 *   max           — Plan limit (0 = unlimited)
 *   overLimit     — true if used >= max
 *   strictlyOver  — true if used > max (editing also blocked)
 */
const OverLimitBanner = ({ resourceName, used, max, overLimit, strictlyOver }) => {
  const navigate = useNavigate();

  if (!overLimit || max === 0) return null;

  const severity = strictlyOver ? 'danger' : 'warning';

  return (
    <div className={`olb olb--${severity}`}>
      <div className="olb__icon">
        <AlertTriangle size={18} />
      </div>
      <div className="olb__body">
        <span className="olb__title">
          {strictlyOver
            ? `Over plan limit — ${used}/${max} ${resourceName}`
            : `Plan limit reached — ${used}/${max} ${resourceName}`}
        </span>
        <span className="olb__desc">
          {strictlyOver
            ? `You have ${used - max} more ${resourceName.toLowerCase()} than your plan allows. You cannot add or edit ${resourceName.toLowerCase()} until you upgrade or remove excess entries.`
            : `You've reached the maximum ${resourceName.toLowerCase()} for your plan. You cannot add new ${resourceName.toLowerCase()} — upgrade to increase your limit.`}
        </span>
      </div>
      <button className="olb__action" onClick={() => navigate('/billing')}>
        Upgrade <ArrowUpRight size={14} />
      </button>
    </div>
  );
};

export default OverLimitBanner;
